import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface VehiclePosition {
  vehicleId: string
  vehicleNumber: string
  latitude: number
  longitude: number
  speedKmh: number | null
  heading: number | null
  timestamp: string
  circuitId: string | null
  circuitName: string | null
  confidenceLevel: number
  associationStatus: 'CONFIRMED' | 'UNCERTAIN' | 'UNASSOCIATED'
  gpsStatus: 'ONLINE' | 'OFFLINE' | 'DELAYED' | 'GPS_LOST'
  // Télémétrie tracker (§5 docs/conception/tracker-serveur.md) — optionnelle selon le boîtier.
  imei?: string | null
  altitude?: number | null
  ignition?: boolean | null
  mainPowerVoltage?: number | null
  backupBatteryPercentage?: number | null
  satellites?: number | null
  hdop?: number | null
  panicButtonPressed?: boolean | null
  doorsOpen?: boolean | null
}

interface VehiclesState {
  positions: Record<string, VehiclePosition>
  totalActive: number
  loading: boolean
}

const initialState: VehiclesState = {
  positions: {},
  totalActive: 0,
  loading: false,
}

const vehiclesSlice = createSlice({
  name: 'vehicles',
  initialState,
  reducers: {
    updatePosition: (state, action: PayloadAction<VehiclePosition>) => {
      state.positions[action.payload.vehicleId] = action.payload
      state.totalActive = Object.keys(state.positions).length
    },
    updatePositions: (state, action: PayloadAction<VehiclePosition[]>) => {
      action.payload.forEach(p => { state.positions[p.vehicleId] = p })
      state.totalActive = action.payload.length
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    /** Purge toutes les positions (ex. arrêt du simulateur). */
    clearPositions: (state) => {
      state.positions = {}
      state.totalActive = 0
    },
    /** Met à jour le statut GPS d'un véhicule (ONLINE / GPS_LOST / OFFLINE) — Phase 4. */
    setGpsStatus: (state, action: PayloadAction<{ vehicleId: string; gpsStatus: VehiclePosition['gpsStatus'] }>) => {
      const v = state.positions[action.payload.vehicleId]
      if (v) v.gpsStatus = action.payload.gpsStatus
    },
  },
})

export const { updatePosition, updatePositions, setLoading, clearPositions, setGpsStatus } = vehiclesSlice.actions
export default vehiclesSlice.reducer
